(ns frontend.view.settings2.web-form.questions
  (:require
   [reagent.core :as r]
   [frontend.conn :as conn]
   [promesa.core :as p]
   [potpuri.core :refer [index-by fn-> fn->>]]
   [common.localization :as loc]
   [common.util :as cu :refer [equals? only-entity empty-string]]
   [common.attribute :as attribute]
   [common.permissions.entity-permissions :as entity-permissions]
   [frontend.logging :as logging]
   [frontend.view.settings2.db :as db]
   [frontend.view.settings2.web-form.events :as events]
   [frontend.state.current-session :as session]
   [ui.components.input.checkbox :as checkbox]
   [clojure.string :as string]
   [frontend.utils :as fu]
   [common.schema.registry :as registry]
   [ui.components.button.view :as button]
   [ui.editors.data-input :as data-input]))

(defn question-view
  [{:keys [question save-question!]}]
  [:div
   [data-input/view
    {:data-type   :data.type/text-simple
     :full-width? true
     :value       question
     :on-blur     (fn [new-value]
                    (when (not= new-value question)
                      (save-question! new-value identity identity)))}]])

(defn length-view
  [{:keys [value save-length!]}]
  [:div
   [data-input/view
    {:data-type   :data.type/integer
     :full-width? true
     :value       value
     :on-blur     (fn [new-value]
                    (when (not= new-value value)
                      (save-length! new-value identity identity)))}]])

(defn field-view
  [{:keys [state]}]
  (let [local-atom (r/atom {:drop-count   0
                            :drag-counted #{}})]
    (fn [{:keys [field config save-question! toggle-mandatory! save-config! remove-field!
                 drag-state on-drag-start! on-drag-end! on-drag-leave on-drag-enter on-drag-over]}]
      (let [tenant @session/tenant
            tenant-schema @session/tenant-schema
            separator? (cu/separator-kw? field)
            label (when-not separator?
                    (attribute/attribute-label tenant-schema field))
            question (or (-> config
                             :question)
                         label)
            field-schema (registry/get-field-schema tenant-schema field)
            {:keys [field/data-type]} field-schema
            show-lengths? (and (not separator?)
                               (some #{data-type}
                                     [:data.type/text-simple :data.type/text-multiline]))
            mandatory? (-> config
                           :mandatory?)
            min-length (-> config
                           :min-length)
            temp-min-length (-> @local-atom
                                :temp-min-length)
            max-length (-> config
                           :max-length)
            temp-max-length (-> @local-atom
                                :temp-max-length)
            drop-count (:drop-count @local-atom)
            id field
            {:keys [drag-id drag-over drop]} @drag-state]
        [:div
         {:class-name    (fu/cs "ps-3 pe-6 w-full flex items-center gap-4 relative
                                 odd:bg-base-regular"
                                (when separator?
                                  "")
                                (when (= drag-id id)
                                  "dragging")
                                (when (and (> drop-count 0)
                                           (= drag-over id)
                                           (not (nil? drag-id))
                                           (not= drag-id id))
                                  (str "dropzone"
                                       (if (= drop :above)
                                         " above"
                                         " below"))))
          :draggable     true
          :on-drag-start (fn [e]
                           (aset e "dataTransfer" "effectAllowed" "move")
                           ;;drag data must be set for dragend to fire in firefox:
                           (.. e -dataTransfer (setData "text" "zapflow"))

                           (on-drag-start! id)
                           (.stopPropagation e))
          :on-drag-end   (fn [me]
                           (.preventDefault me)
                           (.stopPropagation me)
                           (swap! local-atom assoc :drop-count 0 :drag-counted #{})
                           (on-drag-end! nil))
          :on-drop       (fn [e]
                           (.preventDefault e)
                           (.stopPropagation e)
                           (swap! local-atom assoc :drop-count 0 :drag-counted #{})
                           (on-drag-end! drag-over))
          :on-drag-leave (fn [oe]
                           (.stopPropagation oe)
                           (.preventDefault oe)
                           (let [target (->> oe
                                             .-target)
                                 already-counted (some #{(str target)} (:drag-counted @local-atom))
                                 new-count (dec (:drop-count @local-atom))]
                             (swap! local-atom assoc
                                    :drag-counted
                                    (disj (:drag-counted @local-atom) (str target)))
                             (if already-counted
                               (do
                                 (swap! local-atom assoc :drop-count new-count))
                               #_(logging/log "Skip DECREASE :" id "->" new-count "-" target))

                             (when (= new-count 0)
                               (on-drag-leave id))))
          :on-drag-over  (fn [e]
                           (.preventDefault e))
          :on-drag-enter (fn [ee]
                           (.stopPropagation ee)
                           (.preventDefault ee)
                           (let [target (->> ee
                                             .-target)
                                 already-counted (some #{(str target)} (:drag-counted @local-atom))
                                 new-count (inc (:drop-count @local-atom))]
                             (swap! local-atom assoc
                                    :drag-counted
                                    (conj (:drag-counted @local-atom) (str target)))
                             (if-not already-counted
                               (do
                                 (swap! local-atom assoc :drop-count new-count))
                               (do
                                 #_(logging/log "SKIP Increase - " already-counted)))
                             (when (= new-count 1)
                               (on-drag-enter id))))}
         [:div
          {:class-name (fu/cs ""        ;;"card__handle"
                              "w-4 cursor-pointer")}
          [:i.fal.fa-grip-vertical]]
         [:div
          {:class "grid grid-cols-10 gap-4 flex-1 place-content-center items-center"}

          (when-not separator?
            ;;note: this must take 100% of the height, otherwise the drag-reorder
            ;;      will break:
            [:span
             {:class "col-span-3 flex items-center text-xs font-semibold"}
             label])

          [:div
           {:class "col-span-4"}
           [question-view
            {:field          field
             :question       question
             :save-question! save-question!}]]

          (when-not separator?
            [:div
             {:class "px-4 col-span-1 flex items-center"}
             [:span
              [checkbox/view
               {:value      (boolean mandatory?)
                :on-change  (fn [checked?]
                              (toggle-mandatory! (boolean checked?)
                                                 (fn [])
                                                 (fn [e])))}]

              ;; [editor
              ;;  {:editor/type   :editor.type/checkbox
              ;;   :tenant        @session/tenant
              ;;   :tenant-schema @session/tenant-schema
              ;;   :value         (boolean mandatory?)
              ;;   :on-blur!      (fn [e checked?]
              ;;                    (toggle-mandatory! (boolean checked?) (fn []) (fn [e])))}]
              ]])

          (when show-lengths?
            [:div
             {:class "col-span-1"}
             [:span
              [length-view
               {:field        :min-length
                :value        min-length
                :save-length! (partial save-config! :min-length)}]]])

          (when show-lengths?
            [:div
             {:class "col-span-1"}
             [:span
              [length-view
               {:field        :max-length
                :value        max-length
                :save-length! (partial save-config! :max-length)}]]])

          [button/secondary-open
           {:class "absolute right-0 top-1/2 -translate-y-1/2 cursor-pointer"
            :on-click   remove-field!}
           [:i.fal.fa-times]]]]))))

(defn fields-view
  [{:keys []}]
  (let [drag-state (r/atom {})]
    (fn [{:keys [entity-type entity-atom available-fields]}]
      (js/console.log "Render fields : " @entity-atom)
      (let [webentry @entity-atom
            selected-fields (->> (get-in webentry
                                         [:webentry/field-config entity-type :selected-fields])
                                 (filter (fn [k]
                                           (or (cu/separator-kw? k)
                                               (some #{k} available-fields)))))
            field-config (get-in webentry [:webentry/field-config entity-type :field-config])
            save-config! (fn [attribute config-attribute new-value on-success! on-error!]
                           (let [local-path [:webentry/field-config entity-type :field-config
                                             attribute config-attribute]
                                 old-value (get-in local-path webentry)
                                 msg {:db/id            (:db/id webentry)
                                      :entity-type      entity-type
                                      :attribute        attribute
                                      :config-attribute config-attribute
                                      :value            new-value}]
                             (swap! entity-atom assoc-in local-path new-value)
                             (deref entity-atom)
                             (js/console.log "Save optimistic")
                             (-> (conn/sendp! :webentry/update-field msg)
                                 (p/then (fn [_]
                                           (on-success!)))
                                 (p/catch (fn [e]
                                            (when (= (get-in @entity-atom local-path) new-value)
                                              (swap! entity-atom assoc-in local-path old-value))
                                            (on-error!)
                                            (logging/error "error saving config"
                                                           entity-type
                                                           attribute
                                                           config-attribute
                                                           e))))))

            reorder! (fn [dragged-element drop-target direction]
                       (let [ordered selected-fields
                             items (remove #{dragged-element} ordered)
                             head (take-while #(not= % drop-target) items)
                             tail (rest (drop-while #(not= % drop-target) items))
                             middle (if (= direction :below)
                                      [drop-target dragged-element]
                                      [dragged-element drop-target])
                             new-order (vec (concat head middle tail))]
                         (events/save-selected-fields! entity-atom
                                                       entity-type
                                                       selected-fields
                                                       new-order
                                                       nil)))
            remove-field! (fn [selected-fields field]
                            (let [new-fields (->> selected-fields
                                                  (remove (fn [f]
                                                            (= f field)))
                                                  vec)]
                              (events/save-selected-fields! entity-atom
                                                            entity-type
                                                            selected-fields
                                                            new-fields
                                                            field)))]
        [:div
         {:class "border border-solid border-complement-light-border-paler
                  bg-base-light"}
         [:div
          {:class "py-2 pl-4 *:px-2 grid grid-cols-10 gap-4 items-center
                   text-xxs lg:text-xs font-semibold
                   border-b border-solid border-complement-regular-border"}
          [:div
           {:class "col-span-3 leading-3"}
           (loc/tr :web-form-settings/field-mapped)]
          [:div
           {:class "col-span-4 leading-3"}
           (loc/tr :web-form-settings/field-question)]
          [:div
           {:class "col-span-1 leading-3"}
           (loc/tr :web-form-settings/field-mandatory)]
          [:div
           {:class "col-span-1 leading-3"}
           (loc/tr :web-form-settings/field-min-length)]
          [:div
           {:class "col-span-1 leading-3"}
           (loc/tr :web-form-settings/field-max-length)]]
         (doall
          (for [field selected-fields]
            ^{:key (str "f-" field)}
            [field-view
             {:field             field
              :config            (-> field-config
                                     (get field))
              :save-question!    (partial save-config! field :question)
              :toggle-mandatory! (partial save-config! field :mandatory?)
              :save-config!      (partial save-config! field)
              :remove-field!     (partial remove-field! selected-fields field)
              :drag-state        drag-state
              :on-drag-start!    (fn [arg]
                                   (swap! drag-state assoc :drag-id field))
              :on-drag-end!      (fn [drop-target]
                                   (let [drag-id (:drag-id @drag-state)
                                         drop (:drop @drag-state)]
                                     (when (and drag-id
                                                drop-target
                                                (not= drag-id drop-target))
                                       (reorder! drag-id drop-target drop))
                                     (swap! drag-state dissoc :drag-id :drag-over) ;; :drop)
                                     ))
              :on-drag-leave     (fn [arg]
                                   (when (and (not= arg (:drag-id @drag-state))
                                              (= arg (:drag-over @drag-state)))
                                     (swap! drag-state dissoc :drag-over)))
              :on-drag-enter     (fn [arg]
                                   (let [drag-id (:drag-id @drag-state)
                                         dragging-order (.indexOf selected-fields drag-id)
                                         drag-enter-order (.indexOf selected-fields arg)]
                                     (when (not= arg drag-id)
                                       (swap! drag-state assoc :drag-over arg)
                                       (if (> dragging-order drag-enter-order)
                                         (swap! drag-state assoc :drop :above)
                                         (swap! drag-state assoc :drop :below)))))}]))]))))

(defn entity-title-input
  [_args]
  (let [local (r/atom {:dirty? false :value nil})]
    (fn [{:keys [webentry entity-type entity-atom]}]
      (let [info-kw (keyword (name entity-type) "info")
            default-asset-title (loc/tr info-kw)
            local-path [:webentry/field-config entity-type :title]
            old-value (or (get-in webentry local-path) default-asset-title)
            current (if (:dirty? @local) (:value @local) old-value)
            error (when (string/blank? current)
                    "This is a mandatory field. It cannot be cleared")]
        [:div
         [data-input/view
          {:data-type   :data.type/text-simple
           :full-width? true
           :placeholder ""
           :value       current
           :error       error
           :on-change   (fn [new-value]
                          (reset! local {:dirty? true :value new-value}))
           :on-blur     (fn [_]
                          (let [new-value (if (:dirty? @local) (:value @local) old-value)]
                            (when (and (not (string/blank? new-value))
                                       (not= new-value old-value))
                              (swap! entity-atom assoc-in local-path new-value)
                              (-> (conn/sendp! :webentry/update-entity-field
                                               {:db/id       (:db/id webentry)
                                                :entity-type entity-type
                                                :field       :title
                                                :value       new-value})
                                  (p/then (fn []
                                            (reset! local {:dirty? false :value nil})))
                                  (p/catch
                                   (fn [e]
                                     (when (= new-value (get-in @entity-atom local-path))
                                       (swap! entity-atom assoc-in local-path old-value))
                                     (logging/error "error saving title" entity-type e)))))))}]
         (when error
           [:p {:class "text-xs text-danger-light-text"} error])]))))

(defn view
  [{:keys [state edit-state webentry entity-atom system-form?]}]
  (let [state-atom (r/atom {})]
    (fn [{:keys [state edit-state webentry entity-atom system-form?]}]
      (js/console.log "Render questions")
      (let [tenant @session/tenant
            tenant-schema @session/tenant-schema
            teams (->> @session/all-teams
                       (remove :common/disabled?))
            asset-type (or (:webentry/asset-type webentry)
                           :entity.type/company)
            webentry-config (-> webentry
                                :webentry/field-config)

            selected-asset-fields (-> webentry-config
                                      asset-type
                                      :selected-fields)
            tenant-configs (:tenant/field-configurations tenant)

            available-asset-fields
            (entity-permissions/available-webentry-fields asset-type
                                                          teams
                                                          tenant-configs
                                                          tenant
                                                          tenant-schema)
            available-oppo-fields (entity-permissions/available-webentry-fields :entity.type/oppo
                                                                                teams
                                                                                tenant-configs
                                                                                tenant
                                                                                tenant-schema)
            selected-oppo-fields (-> webentry-config
                                     :entity.type/oppo
                                     :selected-fields)
            available-person-fields (entity-permissions/available-webentry-fields
                                     :entity.type/person
                                     teams
                                     tenant-configs
                                     tenant
                                     tenant-schema)
            selected-person-fields (-> webentry-config
                                       :entity.type/person
                                       :selected-fields)
            {:keys [webentry/embed webentry/apikey]} webentry]
        [:div
         {:class "flex flex-col gap-6"}
         [:div
          {:class "p-3 flex flex-col gap-4
                   bg-base-regular"}

          [:div
           [entity-title-input
            {:webentry    webentry
             :entity-type asset-type
             :entity-atom entity-atom
             :state-atom  state-atom}]]
          [:div
           [fields-view
            {:entity-atom      entity-atom
             :entity-type      asset-type
             :available-fields available-asset-fields}]]

          [:div
           {:class "flex items-center gap-4"}
           [:div
            [button/sm-secondary-hollow
             {:on-click   (fn [_]
                            (let [new-field (events/new-separator-kw (name asset-type)
                                                                     selected-asset-fields)
                                  new-fields (vec (concat selected-asset-fields [new-field]))]
                              (events/save-selected-fields! entity-atom
                                                            asset-type
                                                            selected-asset-fields
                                                            new-fields
                                                            nil)))}
             (loc/tr :add-sub-header)]]

           [:div
            [button/secondary-open
             {:class "mb-0 text-sm"
              :on-click   (fn [_]
                            (events/select-fields available-asset-fields
                                                  selected-asset-fields
                                                  (fn [new-fields]
                                                    (events/save-selected-fields!
                                                     entity-atom
                                                     asset-type
                                                     selected-asset-fields
                                                     new-fields
                                                     nil))))}
             (loc/tr :select-fields)]]]]

         [:div
          {:class "p-3 flex flex-col gap-4
                   bg-base-regular"}
          [:div
           [entity-title-input
            {:webentry    webentry
             :entity-type :entity.type/oppo
             :entity-atom entity-atom
             :state-atom  state-atom}]]
          [:div
           [fields-view
            {:entity-atom      entity-atom
             :entity-type      :entity.type/oppo
             :available-fields available-oppo-fields}]]

          [:div
           {:class "flex items-center gap-4"}
           [:div
            [button/sm-secondary-hollow
             {:on-click   (fn [_]
                            (let [new-field (events/new-separator-kw (name :entity.type/oppo)
                                                                     selected-oppo-fields)
                                  new-fields (vec (concat selected-oppo-fields [new-field]))]
                              (events/save-selected-fields! entity-atom
                                                            :entity.type/oppo
                                                            selected-oppo-fields
                                                            new-fields
                                                            nil)))}
             (loc/tr :add-sub-header)]]
           [:div
            [button/secondary-open
             {:class "mb-0 text-sm"
              :on-click   (fn [_]
                            (events/select-fields available-oppo-fields
                                                  selected-oppo-fields
                                                  (fn [new-fields]
                                                    (events/save-selected-fields! entity-atom
                                                                                  :entity.type/oppo
                                                                                  selected-oppo-fields
                                                                                  new-fields
                                                                                  nil))))}
             (loc/tr :select-fields)]]]]

         [:div
          {:class "p-3 flex flex-col gap-4
                   bg-base-regular"}
          [:div
           [entity-title-input
            {:webentry    webentry
             :entity-type :entity.type/person
             :entity-atom entity-atom
             :state-atom  state-atom}]]
          [:div
           [fields-view
            {:entity-atom      entity-atom
             :entity-type      :entity.type/person
             :available-fields available-person-fields}]]

          [:div
           {:class "flex items-center gap-4"}
           [:div
            [button/sm-secondary-hollow
             {:on-click   (fn [_]
                            (let [new-field (events/new-separator-kw (name :entity.type/person)
                                                                     selected-person-fields)
                                  new-fields (vec (concat selected-person-fields [new-field]))]
                              (events/save-selected-fields! entity-atom
                                                            :entity.type/person
                                                            selected-person-fields
                                                            new-fields
                                                            nil)))}
             (loc/tr :add-sub-header)]]
           [:div
            [button/secondary-open
             {:class "mb-0 text-sm"
              :on-click   (fn [_]
                            (events/select-fields available-person-fields
                                                  selected-person-fields
                                                  (fn [new-fields]
                                                    (events/save-selected-fields!
                                                     entity-atom
                                                     :entity.type/person
                                                     selected-person-fields
                                                     new-fields
                                                     nil))))}
             (loc/tr :select-fields)]]]]]))))
